import { render } from "./GradeProgressBar.vue?vue&type=template&id=5fb8d071&scoped=true"
import script from "./GradeProgressBar.vue?vue&type=script&lang=js"
export * from "./GradeProgressBar.vue?vue&type=script&lang=js"

import "./GradeProgressBar.vue?vue&type=style&index=0&id=5fb8d071&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb8d071"]])

export default __exports__